import { render, staticRenderFns } from "./YKEditor.vue?vue&type=template&id=b001a030&scoped=true&"
import script from "./YKEditor.vue?vue&type=script&lang=js&"
export * from "./YKEditor.vue?vue&type=script&lang=js&"
import style0 from "./YKEditor.vue?vue&type=style&index=0&id=b001a030&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b001a030",
  null
  
)

export default component.exports